<template>
  <div class="calendar-container">
    <!-- <div class="calendar-toolbar">
      <el-button-group>
        <el-button @click="changeView('dayGridMonth')" size="small">月视图</el-button>
        <el-button @click="changeView('timeGridWeek')" size="small">周视图</el-button>
        <el-button @click="changeView('timeGridDay')" size="small">日视图</el-button>
      </el-button-group>
    </div> -->
    
    <FullCalendar
      ref="fullCalendar"
      class="coach-calendar"
      :options="calendarOptions"
    />
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import zhLocale from '@fullcalendar/core/locales/zh-cn'

export default {
  components: { FullCalendar },
  props: {
    events: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: 'timeGridWeek',
        locales: [zhLocale],
        locale: 'zh-cn',
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        buttonText: {
          today: '今天',
          month: '月视图',
          week: '周视图',
          day: '日视图'
        },
        events: this.formatEvents(this.events),
        dayMinTime: "11:00:00",
        dayMaxTime: "23:00:00",
        slotDuration: "01:00:00",
        slotLabelInterval: "02:00:00",
        eventColor: '#3788d8',
        eventTextColor: '#fff',
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        },
        eventDidMount: this.styleEvent,
        eventClick: this.handleEventClick,
        datesSet: this.updateHeaderButtons,
        height: 'auto'
      }
    }
  },
  watch: {
    events: {
      handler(newEvents) {
        // 更新日历events
        this.calendarOptions.events = this.formatEvents(newEvents);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    formatEvents(events) {
      console.log("CoachCalendar formatEvents 接收到的events:", events);
      
      if (!events || !Array.isArray(events)) {
        console.log("events 为空或不是数组");
        return [];
      }
      
             return events.filter(event => {
         // 过滤掉缺少必要字段的事件
         const isValid = event && event.startTime && event.jiaolianxingming && event.xingming;
         if (!isValid) {
           console.warn("过滤掉无效事件:", event);
         }
         return isValid;
       }).map(event => {
        try {
          const start = new Date(event.startTime);
          
          // 检查日期是否有效
          if (isNaN(start.getTime())) {
            console.warn("无效的开始时间:", event.startTime);
            return null;
          }
          
          const duration = parseInt(event.duration) || 60; // 默认60分钟
          
        return {
          title: `${event.jiaolianxingming} - ${event.xingming}`,
          start: start,
            end: this.calculateEndTime(start, duration),
            backgroundColor: this.getEventColor(event),
          extendedProps: {
            ...event
          }
          };
        } catch (error) {
          console.error("格式化事件时出错:", error, event);
          return null;
        }
      }).filter(event => event !== null); // 过滤掉null值
    },
    getEventColor(event) {
      // 根据状态返回不同颜色
      if (event.status === 'complete') {
        return '#67C23A'; // 绿色 - 已完成
      } else if (event.status === 'reject') {
        return '#F56C6C'; // 红色 - 已拒绝
      } else if (event.status === 'pending') {
        return '#E6A23C'; // 橙色 - 待处理
      } else {
        return '#3788d8'; // 默认蓝色
      }
    },
    calculateEndTime(start, durationMinutes) {
      const end = new Date(start)
      end.setMinutes(end.getMinutes() + durationMinutes)
      return end
    },
    calculateSlotDuration() {
    // 在这里计算单个事件的 duration
    // 假设 events 是一个包含所有事件的数组
    const totalDuration = this.events.reduce((acc, event) => {
      // 假设每个事件有一个 duration 属性
      return acc + event.duration;
    }, 0);

    // 将总 duration 转换为时间格式
    const hours = Math.floor(totalDuration / 60);
    const minutes = totalDuration % 60;
    const seconds = 0;

    // 返回时间格式的 duration
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  },
    changeView(viewType) {
      const calendarApi = this.$refs.fullCalendar.getApi()
      calendarApi.changeView(viewType)
    },
    styleEvent(info) {
      // 添加自定义事件样式
      info.el.style.cursor = 'pointer'
      info.el.style.borderRadius = '4px'
      info.el.style.boxShadow = '0 2px 5px rgba(0,0,0,0.1)'
    },
    updateHeaderButtons() {
      // 添加自定义按钮样式
      setTimeout(() => {
        document.querySelectorAll('.fc-button').forEach(btn => {
          btn.classList.add('el-button', 'el-button--default', 'el-button--small')
          btn.style.margin = '0 3px'
        })
      }, 50)
    },
    handleEventClick(info) {
      const startTime = this.dateFormat(info.event.start);
      const statusText = this.getStatusText(info.event.extendedProps.status);
      
      this.$alert(`
        <div class="event-detail">
          <p><strong>教练：</strong>${info.event.extendedProps.jiaolianxingming}</p>
          <p><strong>学员：</strong>${info.event.extendedProps.xingming}</p>
          <p><strong>时间：</strong>${startTime}</p>
          <p><strong>状态：</strong><span style="color: ${this.getEventColor(info.event.extendedProps)}">${statusText}</span></p>
          <p><strong>说明：</strong>${info.event.extendedProps.yuyueshuoming || '无'}</p>
        </div>
      `, '预约详情', {
        dangerouslyUseHTMLString: true,
        customClass: 'calendar-event-dialog'
      })
  },
    dateFormat(val) {
      return val.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    getStatusText(status) {
      const statusMap = {
        'pending': '待处理',
        'complete': '已完成',
        'reject': '已拒绝'
      };
      return statusMap[status] || status || '未知';
    }
  }
}
</script>

<style scoped>
.calendar-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,.1);
}

.calendar-toolbar {
  margin-bottom: 15px;
  display: flex;
  justify-content: flex-end;
}

.coach-calendar {
  margin-top: 20px;
}

/* 自定义日历样式 */
:deep(.fc) {
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

:deep(.fc-toolbar-title) {
  font-size: 16px;
  font-weight: 600;
}

:deep(.fc-timeGridDay-view .fc-timegrid-slots),
:deep(.fc-timeGridWeek-view .fc-timegrid-slots) {
  min-height: 600px;
}

:deep(.fc-event) {
  border: none;
  padding: 3px 5px;
}

:deep(.fc-daygrid-event-dot) {
  display: none;
}

/* 自定义对话框样式 */
:deep(.calendar-event-dialog) {
  width: 400px;
  border-radius: 8px;
}

.event-detail p {
  margin: 8px 0;
  line-height: 1.6;
}
</style>